import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/styles.css';
import {
  getUsers,
  deleteUser,
  getFirmas,
  deleteFirma,
  obtenerFirmaBlobUrl,
  getNombresMedico
} from '../services/api';
import { useServerPagination } from '../utils/serverPag';
import FirmaModal from './FirmaModal';
import { confirmar } from './ConfirmModal';
import { toast } from 'react-toastify';


const AdminPanel = () => {
  const {
    items: usuarios,
    page: usersPage,
    total: usersTotal,
    totalPages:usersTotalPages,
    loading: loadingUsers,
    error: errorUsers,
    setPage: setUsersPage,
    refresh: refreshUsuarios
  } = useServerPagination(getUsers,{initialPerPage: 5});

  const navigate = useNavigate();

  /* ----------------- Firmas ------------------ */
  const [searchMedico, setSearchMedico] = useState('');
  const [modalFirmaAbierto, setModalFirmaAbierto] = useState(false);
  const [nombresMedico, setNombresMedico] = useState([]);
  const [firmaVer, setFirmaVer] = useState(null);
  const [errorFirma, setErrorFirma] = useState(null);
  const [firmaBlobUrl, setFirmaBlobUrl] = useState(null);
  const [cargandoFirma, setCargandoFirma] = useState(false);

  const fetchFirmasFn = useCallback(
    (opts) => getFirmas(opts),
    []
  );
  const {
    items: firmas,
    page: firmasPage,
    total: firmasTotal,
    totalPages: firmasTotalPages,
    loading: loadingFirmas,
    error: errorFirmas,
    setPage: setFirmasPage,
    refresh: refreshFirmas
  } = useServerPagination(fetchFirmasFn, { initialPerPage: 10 });

  const cargarNombresMedico = async () => {
    try {
      const { data } = await getNombresMedico();
      setNombresMedico(data?.nombres_medico || []);
    } catch (error) {
      console.error('Error al obtener nombres de médico:', error);
      toast.error('No se pudieron cargar los nombres de médicos disponibles.');
    }
  };

  const abrirModalFirma = () => {
    cargarNombresMedico();
    setModalFirmaAbierto(true);
  };

  const handleBuscarFirmas = () => {
    setFirmasPage(1);
    refreshFirmas({ nombre_medico: searchMedico.trim() });
  };

  const handleVerFirma = async (firma) => {
    if (firmaBlobUrl) {
      URL.revokeObjectURL(firmaBlobUrl);
      setFirmaBlobUrl(null);
    }
    setFirmaVer(firma);
    setCargandoFirma(true);
    setErrorFirma(null);
    try {
      const url = await obtenerFirmaBlobUrl(firma.id_firma);
      setFirmaBlobUrl(url);
    } catch (error) {
      console.error('Error al obtener la firma:', error);
      setErrorFirma('No se pudo cargar la firma.');
    } finally {
      setCargandoFirma(false);
    }
  };

  const handleCerrarVistaFirma = () => {
    if (firmaBlobUrl) URL.revokeObjectURL(firmaBlobUrl);
    setFirmaVer(null);
    setErrorFirma(null);
    setFirmaBlobUrl(null);
  };

  const handleEliminarFirma = async (idFirma, nombreMedico) => {
    if (!(await confirmar(`¿Eliminar la firma de "${nombreMedico}"?`, { variante: 'peligro' }))) return;
    try {
      await deleteFirma(idFirma);
      if (firmaVer?.id_firma === idFirma) handleCerrarVistaFirma();
      refreshFirmas();
    } catch (error) {
      console.error('Error al eliminar firma:', error);
      toast.error(error.response?.data?.message || 'No se pudo eliminar la firma.');
    }
  };

  /* ----------------- Handlers (create / delete) ------------------ */

  const handleEliminarUsuario = async (usuarioId) => {
    if (!(await confirmar('¿Estás seguro de que deseas eliminar este usuario?', { variante: 'peligro' }))) return;
    try {
      const { data } = await deleteUser(usuarioId);
      toast.success(data?.message || 'Usuario eliminado.');
      // fetchUsuarios(usersPage, usersPerPage);
      refreshUsuarios();
    } catch (error) {
      console.error('Error al eliminar usuario:', error.response?.data);
      toast.error(error.response?.data?.error || 'No se pudo eliminar el usuario.');
    }
  };

  const formatLabel = (val) => {
    if (val === undefined || val === null || val === '') return '';
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  };

  const usersPrev = () => { if (usersPage > 1) setUsersPage((p) => p - 1); };
  const usersNext = () => { if (usersPage < usersTotalPages) setUsersPage((p) => p + 1); };

  const firmasPrev = () => { if (firmasPage > 1) setFirmasPage((p) => p - 1); };
  const firmasNext = () => { if (firmasPage < firmasTotalPages) setFirmasPage((p) => p + 1); };

  return (
    <div className="container-admin">
      <div className="container">
        <h2 className="section-title">Usuarios</h2>
        {loadingUsers ? <div>Loading users...</div> : null}
        {errorUsers ? <div className="error">Error cargando usuarios</div> : null}
        <table className="table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Permiso</th>
              <th>Tipo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((usuario) => (
              <tr key={usuario.id_usuario}>
                <td>{usuario.email}</td>
                <td>{formatLabel(usuario.permiso)}</td>
                <td>{formatLabel(usuario.tipo)}</td>
                <td>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleEliminarUsuario(usuario.id_usuario)}
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
            {usuarios.length === 0 && !loadingUsers && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center' }}>No hay usuarios en esta página.</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination-controls">
          <button onClick={usersPrev} disabled={usersPage <= 1 || loadingUsers}>Prev</button>
          <span> Página {usersPage} de {usersTotalPages} — {usersTotal} usuarios</span>
          <button onClick={usersNext} disabled={usersPage >= usersTotalPages || loadingUsers}>Next</button>
        </div>
      </div>
      <button className='btn-create' onClick={()=>navigate('/admin/usuarios/crear')}>Crear Nuevo Usuario</button>

      {/* ----------------- Firmas de médicos evaluadores ----------------- */}
      <div className="container">
        <h2 className="section-title">Firmas de Médicos Evaluadores</h2>
        <p style={{ color: '#666' }}>
          Firma escaneada del médico que aparece incrustada en la ficha médica (se asocia por el nombre
          del médico que se elige al crear cada evaluación).
        </p>

        <form className="form-search" onSubmit={(e) => { e.preventDefault(); handleBuscarFirmas(); }}>
          <div className="form-block">
            <label htmlFor="buscar-medico">Buscar por médico:</label>
            <input
              type="text"
              id="buscar-medico"
              className="form-control"
              placeholder="Nombre del médico"
              value={searchMedico}
              onChange={(e) => setSearchMedico(e.target.value)}
            />
          </div>
          <button type="submit" className="btn-create">Buscar</button>
        </form>

        {errorFirmas ? <div className="error">Error cargando firmas</div> : null}

        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Médico</th>
                <th>Archivo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {firmas.map((firma) => (
                <tr key={firma.id_firma}>
                  <td>{firma.nombre_medico}</td>
                  <td>{firma.original_name}</td>
                  <td>
                    <button type="button" className="btn-icon" onClick={() => handleVerFirma(firma)}>
                      <i className="fas fa-eye"></i> Ver
                    </button>
                    {' '}
                    <button
                      type="button"
                      className="btn-icon"
                      style={{ backgroundColor: '#dc2626', color: '#fff' }}
                      onClick={() => handleEliminarFirma(firma.id_firma, firma.nombre_medico)}
                    >
                      <i className="fas fa-trash"></i> Eliminar
                    </button>
                  </td>
                </tr>
              ))}
              {firmas.length === 0 && !loadingFirmas && (
                <tr>
                  <td colSpan={3} style={{ textAlign: 'center' }}>No hay firmas cargadas.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="pagination-controls">
          <button onClick={firmasPrev} disabled={firmasPage <= 1 || loadingFirmas}>Prev</button>
          <span> Página {firmasPage} de {firmasTotalPages} — {firmasTotal} firmas</span>
          <button onClick={firmasNext} disabled={firmasPage >= firmasTotalPages || loadingFirmas}>Next</button>
        </div>
      </div>
      <button className='btn-create' onClick={abrirModalFirma}>Subir Firma</button>

      <FirmaModal
        isOpen={modalFirmaAbierto}
        onClose={() => setModalFirmaAbierto(false)}
        nombresDisponibles={nombresMedico}
        onSuccess={() => refreshFirmas()}
      />

      {/* Vista previa segura (Blob) de la firma */}
      {firmaVer && (
        <div className="modal-overlay" onClick={handleCerrarVistaFirma}>
          <div className="modal-container" style={{ maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Firma: {firmaVer.nombre_medico}</h3>
              <button type="button" className="btn-close" onClick={handleCerrarVistaFirma}>&times;</button>
            </div>
            <div className="modal-body" style={{ textAlign: 'center' }}>
              {cargandoFirma && <p>Cargando firma...</p>}
              {errorFirma && <p className="required-text">{errorFirma}</p>}
              {!cargandoFirma && firmaBlobUrl && (
                <img
                  src={firmaBlobUrl}
                  alt={`Firma de ${firmaVer.nombre_medico}`}
                  style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn-secondary" onClick={handleCerrarVistaFirma}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
